// likely not exhaustive

/**
 * typeof without all the footguns
 * e.g.
 * ```ts
 * type([]); // -> 'array'
 * type(null); // -> 'null'
 * type(undefined); // -> 'undefined'
 * type(new Number(2)); // -> 'number'
 * ``` */
export function kind(t) {
  return Object.prototype.toString.call(t).slice(8, -1).toLowerCase();
}

/**
 * Type guard for None
 * @param nullable any value that is Nullable
 * @returns boolean
 *
 * isNone(null) -> true
 * isNone(undefined) -> true
 * isNone('') -> false
 * isNone(0) -> false
 * isNone(false) -> false
 * isNone({}) -> false
 * isNone([]) -> false */
export function isNone(nullable) {
  return kind(nullable) === 'null' || kind(nullable) === 'undefined';
}

/**
 * Type guard for T
 * @param nullable any value that is Nullable
 * @returns boolean
 *
 * isSome(null) -> false
 * isSome(undefined) -> false
 * isSome('') -> true
 * isSome(0) -> true
 * isSome(false) -> true
 * isSome({}) -> true
 * isSome([]) -> true */
export function isSome(nullable) {
  return !isNone(nullable);
}
export function isError(error) {
  return error instanceof Error;
}
export function isString(x) {
  return kind(x) === 'string';
}
export function isObject(x) {
  return kind(x) === 'object';
}
export function isNumeric(value) {
  return kind(value) === 'number' && !isNaN(value);
}
export function isBoolean(x) {
  return kind(x) === 'boolean';
}
export function isDate(x) {
  return x instanceof Date;
}